import { render, staticRenderFns } from "./ShareForm.vue?vue&type=template&id=cac6a05a"
import script from "./ShareForm.vue?vue&type=script&lang=js"
export * from "./ShareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports